import {Flex, Spacer} from '@chakra-ui/react';
import {LanguageSelector} from 'components';
import {useLanguageHook} from 'modules/i18n/hooks';
import React from 'react';
import {MobileLogo} from './MobileLogo';

export const MobileTop: React.FC = () => {
	const {changePreferredlanguage} = useLanguageHook();

	const onChangeLanguage = (language: string) => {
		// only if logged in
		if (changePreferredlanguage) {
			changePreferredlanguage.execute(language);
		}
	};

	return (
		<Flex pt={5} px={5} width='100%'>
			<Flex height='100%' pt={1}>
				<MobileLogo image='/images/logo-mobile.svg' />
			</Flex>
			<Spacer />
			<Flex alignItems='flex-end'>
				<LanguageSelector onChange={onChangeLanguage} />
			</Flex>
		</Flex>
	);
};
